import { createSelector } from "reselect"
import JsCookies from "js-cookie"

import RESULTS_VIEW_TYPES from "common/consts/resultViewTypes"
import Options from "../../records/Options"
import { getNextVersion } from "../abTesting/abTesting"

export default function OptionsReducer(state = new Options(), action) {
  switch (action.type) {
    case "SET_CUSTOMER_VERIFIED":
      return state.set("customerVerified", true)
    case "SET_CURRENCY":
      return state.set("currency", action.currency)

    case "SET_CURRENCY_SUCCESS":
      return state.set("currency", action.currency)

    case "SET_OPTION":
      return state.set(action.option, action.value)

    case "TOGGLE_OPTION":
      if (action.option === "preferredResultsView") {
        return state.set(
          action.option,
          state.get(action.option) === RESULTS_VIEW_TYPES.AUTO
            ? RESULTS_VIEW_TYPES.LIST
            : RESULTS_VIEW_TYPES.AUTO,
        )
      }
      return state.set(action.option, !state.get(action.option))

    case "SWITCH_AB_VERSION": {
      const oldVersion = state.getIn(["simpleABVersions", action.slot])
      const newVersion = getNextVersion(action.slot, oldVersion)
      JsCookies.set(`force_ab_version_${action.slot}`, newVersion) // Not nice in reducer
      return state.setIn(["simpleABVersions", action.slot], newVersion)
    }

    default:
      return state
  }
}

export const getOptions = state => state.options

export const getLocationsApiUrl = createSelector(
  getOptions,
  state => state.locationsApiUrl,
)

export const getSimpleABVersions = createSelector(
  getOptions,
  state => state.simpleABVersions,
)

export const getLanguage = createSelector(
  getOptions,
  state => state.language,
)

export const getCountry = createSelector(
  getOptions,
  state => state.country,
)

export const getApiUrl = createSelector(
  getOptions,
  state => state.apiUrl,
)

export const getBookingApiUrl = createSelector(
  getOptions,
  state => state.bookingApiUrl,
)

export const getPICIApiUrl = createSelector(
  getOptions,
  state => state.piciApiUrl,
)

export const getCurrency = createSelector(
  getOptions,
  state => state.currency,
)

export const getAffiliateThisSession = createSelector(
  getOptions,
  state => state.affiliateThisSession,
)

export const getDebugPaymentGateway = createSelector(
  getOptions,
  state => state.paymentMethodType,
)

export const getRawAffilId = createSelector(
  getOptions,
  state => state.affiliate,
)

export const getBranding = createSelector(
  getOptions,
  state => state.branding,
)

export const getBrandingAffilId = createSelector(
  getBranding,
  state => state.get("affilid"),
)

export const getEnableHiddenFeatures = createSelector(
  getOptions,
  state => state.enableHiddenFeatures,
)

export const getApiKey = createSelector(
  getOptions,
  state => state.apiKey,
)
